// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_summary":"summary_mypage_subsc_summary__1AJUk"};